import type { ChatStep } from "@/lib/api/chat";

export interface WalkthroughStep {
  target: string;
  description: string;
}

/**
 * Build a canonical spotlight walkthrough from chat steps.
 * Prefer explicit multi-target tours, then append any single-step highlights.
 */
export function buildWalkthroughSteps(
  steps: readonly Pick<ChatStep, "text" | "highlightTarget" | "tourTargets">[],
): WalkthroughStep[] {
  const seenTargets = new Set<string>();
  const walkthrough: WalkthroughStep[] = [];

  for (const step of steps) {
    const candidates: WalkthroughStep[] = [];

    if (Array.isArray(step.tourTargets) && step.tourTargets.length > 0) {
      candidates.push(
        ...step.tourTargets.map((tourTarget) => ({
          target: tourTarget.target,
          description: tourTarget.description,
        })),
      );
    }

    if (step.highlightTarget) {
      candidates.push({
        target: step.highlightTarget,
        description: step.text,
      });
    }

    for (const candidate of candidates) {
      if (seenTargets.has(candidate.target)) {
        continue;
      }

      seenTargets.add(candidate.target);
      walkthrough.push(candidate);
    }
  }

  return walkthrough;
}
